import apiClient from '../api/apiClient';

export const getAiSourcesRisqueSuggestions = async (data) => {
  try {
    const requestData = {
      ...data,
      timestamp: Date.now(),
      requestMore: data.requestMore || false
    };

    const response = await apiClient.post('/ai/suggest-sources-risque', requestData);
    console.log('AI suggestion response:', response);

    return response;
  } catch (error) {
    console.error('Error getting AI sources de risque suggestions:', error);
    throw error;
  }
};

// REMOVED: saveSourceRisque, updateSourceRisque — POST to /components and /components/:id which have no matching routes
